// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import {myBackendFunction} from 'backend/aModule.jsw';


$w.onReady(function () {
	//TODO: write your page related code here...
	/* 
	var p = $w('#productPage1').getProduct();
	console.log(p);
*/
	$w("#verticalMenu1").hide();
	$w("#box1").hide();
	let menu_show = 0;
	
	$w("#button17").onClick( (event) => {
  		if(menu_show === 0) {
			$w("#verticalMenu1").show();
			menu_show = 1;
		  }
		else if(menu_show === 1) {
			 $w("#verticalMenu1").hide();
			 menu_show = 0 
		  }
	} );
});

function renderOpt() {
	$w('#productPage1').getProduct()
  	.then( (product) => {
    	let productName = product.name;
    	let productDescription = product.description;
		let productPrice = product.price;
		let productSku = product.sku;
		let productId = product._id;
		let productTax = 1.17;
		let productFullPrice = productTax * productPrice;
		productFullPrice = Math.round(productFullPrice * 100) / 100;
    	// see example product object below
		let priceTxt = '₪ ' + productFullPrice.toString();
		$w('#text41').text = priceTxt;
		$w('#text43').text = '₪ ' + productPrice.toString();
		let opt = product.productOptions["עמידות למים"].choices[0].value;
		console.log(opt);
		
		//let optLen = opt.choices.length;
		/*if(productSku ===  undefined) {
			console.log("hhh");
		}*/
		
		myBackendFunction(productId)
  			.then( (availability) => {
      			let available = availability.availableForPurchase;  // true
     			let options = availability.productOptions;          // see below
      			let mainMedia = availability.mainMedia;
      			let mediaItems = availability.mediaItems;
      			let selectedVariant = availability.selectedVariant; // see below
				console.log(selectedVariant);
  			} )
  			.catch( (error) => {
    			console.log(error);
  			} );
		
  		} )
  	.catch( (error) => {
    		console.log(error);
  	} );

	

	  
}


